//@ts-check

/**
 * @type {import('./types').xml2jsonType}
 */
function xml2json(xml) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}; // Create the return object

  var obj = {};
  var attributesKey = options.attributesKey || '@attributes';

  if (xml.nodeType == 1) {
    // element
    // do attributes
    obj[attributesKey] = {};

    if (xml.attributes.length > 0) {
      for (var j = 0; j < xml.attributes.length; j++) {
        var attribute = xml.attributes.item(j);
        var attributeName = typeof options.attributeNameFn === 'function' ? options.attributeNameFn(attribute.nodeName) : attribute.nodeName;
        obj[attributesKey][attributeName] = attribute.nodeValue;
      }
    }
  } else if (xml.nodeType == 3) {
    // text
    obj = xml.nodeValue;
  } // do children


  if (xml.hasChildNodes()) {
    for (var i = 0; i < xml.childNodes.length; i++) {
      var item = xml.childNodes.item(i);
      var nodeName = typeof options.elementNameFn === 'function' ? options.elementNameFn(item.nodeName) : item.nodeName;

      if (typeof obj[nodeName] == 'undefined') {
        obj[nodeName] = xml2json(item, options);
      } else {
        if (typeof obj[nodeName].push == 'undefined') {
          var old = obj[nodeName];
          obj[nodeName] = [];
          obj[nodeName].push(old);
        }

        obj[nodeName].push(xml2json(item, options));
      }
    }
  }

  return obj;
}

export default xml2json;